import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { authRoles } from 'app/auth';

import AppointmentProvider from './context/AppointmentContext';

import AppointmentDetailsLayout from './layouts/AppointmentDetailsLayout';

const AppointmentDetailsPage = lazy(() => import('./use-cases/appointment-details'));
const AppointmentQuestionnairePage = lazy(() => import('./use-cases/appointment-questionnaire'));
const AppointmentOutcomePage = lazy(() => import('./use-cases/appointment-outcome'));
const AppointmentPatientInfoPage = lazy(() =>
  import('./use-cases/appointment-patient/AppointmentPatientInfoPage')
);
const AppointmentPatientAppointmentsPage = lazy(() =>
  import('./use-cases/appointment-patient/AppointmentPatientAppointmentsPage')
);
const AppointmentPatientOrdersPage = lazy(() =>
  import('./use-cases/appointment-patient/AppointmentPatientOrdersPage')
);
const AppointmentPatientMedicationsPage = lazy(() =>
  import('./use-cases/appointment-patient/AppointmentPatientMedicationsPage')
);
const AppointmentPatientMessagesPage = lazy(() =>
  import('./use-cases/appointment-patient/AppointmentPatientMessagesPage')
);
const CreateServiceAppointmentPage = lazy(() => import('./use-cases/create-service-appointment'));
const CreatePharmacyFirstAppointmentPage = lazy(() =>
  import('./use-cases/create-pharmacy-first-appointment')
);

const AppointmentsConfig = {
  settings: {
    layout: {
      config: {
        topBanner: {
          display: false,
        },
        footer: {
          display: false,
        },
        healtheraHeader: {
          display: false,
        },
      },
    },
  },
  auth: authRoles.pharmacist,
  routes: [
    {
      path: 'appointments/create',
      element: <CreateServiceAppointmentPage />,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: true,
              },
            },
          },
        },
      },
    },
    {
      path: 'appointments/create-pharmacy-first/:serviceId',
      element: <CreatePharmacyFirstAppointmentPage />,
      settings: {
        layout: {
          config: {
            healtheraHeader: {
              display: true,
              options: {
                pharmacySelector: true,
              },
            },
          },
        },
      },
    },
    {
      path: 'appointments/:appointmentId',
      element: <Navigate to="details" replace />,
    },
    {
      path: 'appointments/:appointmentId/details',
      element: (
        <AppointmentProvider>
          <AppointmentDetailsLayout>
            <AppointmentDetailsPage />
          </AppointmentDetailsLayout>
        </AppointmentProvider>
      ),
    },
    {
      path: 'appointments/:appointmentId/questionnaire',
      element: (
        <AppointmentProvider>
          <AppointmentDetailsLayout>
            <AppointmentQuestionnairePage />
          </AppointmentDetailsLayout>
        </AppointmentProvider>
      ),
    },
    {
      path: 'appointments/:appointmentId/outcome',
      element: (
        <AppointmentProvider>
          <AppointmentDetailsLayout>
            <AppointmentOutcomePage />
          </AppointmentDetailsLayout>
        </AppointmentProvider>
      ),
    },
    {
      path: 'appointments/:appointmentId/patient',
      element: (
        <AppointmentProvider>
          <AppointmentDetailsLayout>
            <AppointmentPatientInfoPage />
          </AppointmentDetailsLayout>
        </AppointmentProvider>
      ),
    },
    {
      path: 'appointments/:appointmentId/patient-appointments',
      element: (
        <AppointmentProvider>
          <AppointmentDetailsLayout>
            <AppointmentPatientAppointmentsPage />
          </AppointmentDetailsLayout>
        </AppointmentProvider>
      ),
    },
    {
      path: 'appointments/:appointmentId/patient-orders',
      element: (
        <AppointmentProvider>
          <AppointmentDetailsLayout>
            <AppointmentPatientOrdersPage />
          </AppointmentDetailsLayout>
        </AppointmentProvider>
      ),
    },
    {
      path: 'appointments/:appointmentId/patient-medications',
      element: (
        <AppointmentProvider>
          <AppointmentDetailsLayout>
            <AppointmentPatientMedicationsPage />
          </AppointmentDetailsLayout>
        </AppointmentProvider>
      ),
    },
    {
      path: 'appointments/:appointmentId/patient-messages',
      element: (
        <AppointmentProvider>
          <AppointmentDetailsLayout>
            <AppointmentPatientMessagesPage />
          </AppointmentDetailsLayout>
        </AppointmentProvider>
      ),
    },
  ],
};

export default AppointmentsConfig;
